import { z } from 'zod';

import { CompanyId, CustomTemplateId, UserId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';

export const CustomTemplate = z.object({
  id: CustomTemplateId,
  stableId: z.uuid(),
  name: z.string(),
  carboneTemplateId: z.string().min(1),
  companyId: CompanyId,
  createdById: UserId,
  version: z.number().int().min(0),
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type CustomTemplate = z.infer<typeof CustomTemplate>;

export const CustomTemplateInput = CustomTemplate.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});
export type CustomTemplateInput = z.infer<typeof CustomTemplateInput>;
